import styled from 'styled-components'

const HideOnSmallerMobile = styled.div`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `}
`
const HideOnMobile = styled.div`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
  `}
`

const ShowOnSmallerMobile = styled.div`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: block;
  `}
`

const ShowOnMobile = styled.div`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: block;
  `}
`

export { HideOnMobile, HideOnSmallerMobile, ShowOnSmallerMobile, ShowOnMobile }
